import { render, staticRenderFns } from "./SocialSecurityNumber.vue?vue&type=template&id=0e458080&"
import script from "./SocialSecurityNumber.vue?vue&type=script&lang=js&"
export * from "./SocialSecurityNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports